import React from 'react';

import { CustomOperatorValue, isFileTypeLabel } from '@aline/common';
import type { GridFilterInputValueProps, GridFilterOperator } from '@mui/x-data-grid-premium';

import { getIsFileTypeFilterItem } from './file-type-grid-filter';
import { FileTypeAutocompleteFilter } from './FileTypeAutocompleteFilter';

export const fileTypeAnyOfFilterOperator: GridFilterOperator = {
  InputComponent: (props: GridFilterInputValueProps) => <FileTypeAutocompleteFilter {...props} />,
  getApplyFilterFn: (filterItem, _column) => {
    if (
      !filterItem.field ||
      !Array.isArray(filterItem.value) ||
      !filterItem.operator ||
      !getIsFileTypeFilterItem(filterItem)
    )
      return null;

    const filterLabels = new Set(filterItem.value.map(ft => ft.label));

    return (value, _row, _col, _apiRef) => {
      if (filterLabels.size === 0) return true;
      if (typeof value !== 'string' || !isFileTypeLabel(value)) return false;
      return filterLabels.has(value);
    };
  },
  label: 'is any of',
  value: CustomOperatorValue.FileType,
};

export const fileTypeNotAnyOfFilterOperator: GridFilterOperator = {
  InputComponent: (props: GridFilterInputValueProps) => <FileTypeAutocompleteFilter {...props} />,
  getApplyFilterFn: (filterItem, _column) => {
    if (
      !filterItem.field ||
      !Array.isArray(filterItem.value) ||
      !filterItem.operator ||
      !getIsFileTypeFilterItem(filterItem)
    )
      return null;

    const filterLabels = new Set(filterItem.value.map(ft => ft.label));

    return (value, _row, _col, _apiRef) => {
      if (filterLabels.size === 0) return true;
      if (typeof value !== 'string') return true;
      // Unknown labels (fallback path of `getMimeTypeDisplayLabel`) can't
      // be in the user's selection set, so they pass the negation.
      if (!isFileTypeLabel(value)) return true;
      return !filterLabels.has(value);
    };
  },
  label: 'is none of',
  value: CustomOperatorValue.FileTypeNotAnyOf,
};

export const allFileTypeFilters = [fileTypeAnyOfFilterOperator, fileTypeNotAnyOfFilterOperator];
